// Champ de formulaire SELFCNTRL : libellé tracké, saisie soulignée, erreur.
// Le bouton Afficher/Masquer n'apparaît que sur les mots de passe.
import { useState } from 'react'
import { useT } from '../../lib/i18n'

export default function Field ({
  id, label, type = 'text', value, onChange,
  placeholder, error, autoComplete, hint, enterKeyHint
}) {
  const t = useT()
  const [reveal, setReveal] = useState(false)
  const isPass = type === 'password'
  // Sur téléphone, iOS met une majuscule et autocorrige le premier caractère
  // d'un champ e-mail : « Toi@… » ou un mot « corrigé » partent au serveur,
  // l'inscription échoue, et le visiteur repart. On coupe ces automatismes et
  // on demande le clavier e-mail (avec @ et .fr sous le pouce).
  const isEmail = type === 'email'

  return (
    <div className={`u-fld${error ? ' u-fld--err' : ''}`}>
      <label htmlFor={id}>{label}</label>

      <div className="u-fld__wrap">
        <input
          id={id}
          type={isPass && reveal ? 'text' : type}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          inputMode={isEmail ? 'email' : undefined}
          autoCapitalize={isEmail ? 'none' : undefined}
          autoCorrect={isEmail ? 'off' : undefined}
          spellCheck={isEmail ? false : undefined}
          enterKeyHint={enterKeyHint}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-err` : undefined}
        />
        {isPass && (
          <button
            type="button"
            className="u-fld__eye"
            onClick={() => setReveal(!reveal)}
            aria-label={reveal ? t.field.hidePassword : t.field.showPassword}
          >
            {reveal ? t.field.hide : t.field.show}
          </button>
        )}
      </div>

      {error && <p className="u-fld__err" id={`${id}-err`}>{error}</p>}
      {!error && hint && <p className="u-fld__hint">{hint}</p>}
    </div>
  )
}
